// extracted by mini-css-extract-plugin
export default {"layout":"Login_layout__OmeL+","card":"Login_card__8kvKY","content":"Login_content__yIENw","content__title":"Login_content__title__qKp-V"};